import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useCallback } from 'react';
import { FileUploaderViaFirebaseStorage } from 'libs.firebase_react';
import { useLocalizeMessage, ModalWindow, Spinner } from 'libs.nucleus';
import { useBooleanState } from 'libs.react';
export const ImportModalV2 = ({ onModalClose, onHandleImport, isLoading = false }) => {
    const t = useLocalizeMessage();
    const [files, setFiles] = useState({});
    const [isFilesLoading, setFilesLoading, setFilesLoaded] = useBooleanState();
    const onModalWindowClose = () => {
        onModalClose();
    };
    const onDoneClick = () => {
        onHandleImport({ files: Object.values(files).map((file) => file.firebaseUrl) });
    };
    const handleFileChange = useCallback((files) => {
        setFiles(files);
    }, [setFiles]);
    const handleFilesLoading = useCallback(() => {
        setFilesLoading();
    }, []);
    const handleFilesLoaded = useCallback(() => {
        setFilesLoaded();
    }, []);
    const doneButton = {
        label: t('Import'),
        onClick: onDoneClick,
        disabled: Object.keys(files).length === 0 || isFilesLoading,
        content: isLoading ? (_jsx("div", { className: 'py-1', children: _jsx(Spinner, { size: 'sm', variant: 'alt' }) })) : undefined,
    };
    const closeButton = {
        label: t('Cancel'),
        onClick: onModalWindowClose,
        disabled: isLoading,
    };
    return (_jsx(ModalWindow, { title: t('Import translations'), isOpen: true, closeWindow: onModalWindowClose, footerPrimaryActionButton: doneButton, footerSecondaryActionButtons: [closeButton], width: 'base', children: _jsx(FileUploaderViaFirebaseStorage, { storageBaseUrl: 'uploads/import_v2', label: t('Select translation files'), accept: '.json,.zip', multiple: true, onFileChange: handleFileChange, description: t('Upload individual or multiple files using .json or .zip formats.'), buttonLabel: t('Upload'), onLoaded: handleFilesLoaded, onSetFiles: handleFilesLoading }, '1') }));
};
